import React, { useEffect, useState } from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'
import FrontLoader from '../component/layout/FrontLoader';

function ExcelSheet(prop: any) {
    const [loading, setLoading] = useState(true);


    return (
        <>

            <div className="modal fade com-modal text-center show excel-modal" id="sheetModal" aria-labelledby="sheetLabel" aria-hidden="true" style={{ display: "block" }} >
                <div className="modal-dialog modal-dialog-centered modal-xl w-auto">
                    <div className="modal-content ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="sheetLabel">{prop?.fileName}</h5>
                            <button onClick={() => prop.handleClose()} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body p-0">
                            {loading ?

                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(255,255,255,0.8)",
                                        zIndex: 10,
                                    }}
                                >
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                : null}
                            <iframe
                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(prop?.data)}`}
                                style={{ width: "100%", height: "80vh" }}
                                frameBorder="0"
                                title="Excel Preview"
                                onLoad={() => setLoading(false)}
                            ></iframe>

                        </div>
                        <div className="modal-footer d-flex p-3">
                            <button type="submit" onClick={() => prop.handleClose()} className="round-btn com-btn-outline m-0 ms-auto me-3" >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="me-2"
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H2.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.498.498 0 0 1 0-.708l5-5a.5.5 0 1 1 .708.708L2.707 7.5H14.5A.5.5 0 0 1 15 8z" />
                                </svg>
                                {LanguageConstants?.BACK}</button>
                            <button type="submit" className="round-btn m-0" onClick={() => prop.handleClose()} >

                                {LanguageConstants?.IMPORT}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="ms-2"
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-4.147-4.146a.5.5 0 0 1 .708-.708l5 5a.498.498 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExcelSheet